import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=da6ae60e&"
import script from "./Inicio.vue?vue&type=script&lang=js&"
export * from "./Inicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Inicio.vue"
export default component.exports